/* istanbul ignore file */
/* tslint:disable */

import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
import type {
  AcceptOnBehalfOfCustomerDto,
  CreateNewRuleDto,
  CustomerConfirmationDto,
  DefaultEmailsDto,
  GetCustomerEmailContentDataDto,
  RuleDto,
  RuleMetadataDto,
  SaveRuleDto,
  SendForApprovalPostRequestDto,
  SendForInternalApprovalDto,
  SendInfoEmailToCustomerDto,
  SendPreviewForCustomerDto,
  SendPreviewForInternalDto,
  SendPreviewInfoEmailDto,
  SubmitInternalAcceptance,
  SubmitInternalRejection,
  UpdateRuleMetadataDto
} from '../index'

export class ApprovalsApiService {
  public static sendForCustomerApproval(
    requestBody: SendForApprovalPostRequestDto
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/send-for-customer-approval',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: 'Bad Request',
        404: 'Not Found'
      }
    })
  }

  public static sendForCustomerAttachments(
    quotationId: string,
    formData?: {
      files: Blob[]
    }
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/send-for-customer-approval-attachments',
      query: {
        quotationId
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: 'Bad Request',
        404: 'Not Found'
      }
    })
  }

  public static getCustomerInformationData(
    quotationId: string,
    secret: string,
    tenant: string
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/get-customer-confirmation-data',
      query: {
        quotationId,
        secret,
        tenant
      },
      errors: {
        400: 'Bad Request',
        404: 'Not Found'
      }
    })
  }

  public static submitCustomerConfirmation(
    requestBody: CustomerConfirmationDto
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/submit-customer-confirmation',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: 'Bad Request',
        404: 'Not Found'
      }
    })
  }

  public static acceptOnBehalfOfCustomerAttachments(
    quotationId: string,
    formData?: {
      files: Blob[]
    }
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/accept-on-behalf-of-customer-attachments',
      query: {
        quotationId
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: 'Bad Request',
        404: 'Not Found'
      }
    })
  }

  public static acceptOnBehalfOfCustomer(
    requestBody: AcceptOnBehalfOfCustomerDto
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/accept-on-behalf-of-customer',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: 'Bad Request',
        404: 'Not Found'
      }
    })
  }

  public static sendForInternalApprovalAttachments(
    quotationId: string,
    formData?: {
      files: Blob[]
    }
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/send-for-internal-approval-attachment',
      query: {
        quotationId
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: 'Bad Request',
        404: 'Not Found'
      }
    })
  }

  public static sendForInternalApproval(
    requestBody: SendForInternalApprovalDto
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/send-for-internal-approval',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: 'Bad Request',
        404: 'Not Found'
      }
    })
  }

  public static checkAndApplyRules(
    quotationId: string
  ): CancelablePromise<DefaultEmailsDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/check-and-apply-rules',
      query: {
        quotationId
      },
      errors: {
        400: 'Bad Request',
        404: 'Not Found'
      }
    })
  }

  public static getApproversLevelsData(
    quotationId: string
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/get-approvers-levels-data',
      query: {
        quotationId
      },
      errors: {
        400: 'Bad Request',
        404: 'Not Found'
      }
    })
  }

  public static submitInternalAcceptanceLevelOne(
    requestBody: SubmitInternalAcceptance
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/submit-internal-acceptance-level-one',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: 'Bad Request',
        404: 'Not Found'
      }
    })
  }

  public static submitInternalAcceptanceLevelTwo(
    requestBody: SubmitInternalAcceptance
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/submit-internal-acceptance-level-two',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: 'Bad Request',
        404: 'Not Found'
      }
    })
  }

  public static submitInternalRejectionLevelOne(
    requestBody: SubmitInternalRejection
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/submit-internal-rejection-level-one',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: 'Bad Request',
        404: 'Not Found'
      }
    })
  }

  public static submitInternalRejectionLevelTwo(
    requestBody: SubmitInternalRejection
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/submit-internal-rejection-level-two',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: 'Bad Request',
        404: 'Not Found'
      }
    })
  }

  public static returnToDraft(requestBody: {
    quotationId: string
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/return-to-draft',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: 'Bad Request',
        404: 'Not Found'
      }
    })
  }

  public static sendPreviewForCustomerApproval(
    requestBody: SendPreviewForCustomerDto
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/send-preview-for-customer-approval',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: 'Bad Request',
        404: 'Not Found'
      }
    })
  }

  public static sendPreviewForInternalApproval(
    requestBody: SendPreviewForInternalDto
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/send-preview-for-internal-approval',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: 'Bad Request',
        404: 'Not Found'
      }
    })
  }

  public static sendInfoEmailToCustomer(
    requestBody: SendInfoEmailToCustomerDto
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/send-informing-email-to-customer',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: 'Bad Request',
        404: 'Not Found'
      }
    })
  }

  public static sendPreviewInfoEmail(
    requestBody: SendPreviewInfoEmailDto
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/send-preview-informing-customer-email-to-owner',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: 'Bad Request',
        404: 'Not Found'
      }
    })
  }

  public static getAllRules(): CancelablePromise<RuleMetadataDto[]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/GetAllRules',
      errors: {
        404: 'Not Found'
      }
    })
  }

  public static createRule(
    requestBody: CreateNewRuleDto
  ): CancelablePromise<RuleMetadataDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/CreateRule',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: 'Not Found'
      }
    })
  }

  public static updateRule(
    updateData: UpdateRuleMetadataDto
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/updateRuleMetadata',
      body: updateData,
      mediaType: 'application/json',
      errors: {
        400: 'Bad Request',
        404: 'Not Found'
      }
    })
  }

  public static getRule(id: number): CancelablePromise<RuleDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/rule',
      query: { id },
      errors: {
        400: 'Bad Request',
        404: 'Not Found'
      }
    })
  }

  public static activateRule(id: number): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/ActivateRule',
      query: { id },
      errors: {
        400: 'Bad Request',
        404: 'Not Found'
      }
    })
  }

  public static deleteRule(ruleId: number): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/rule',
      query: { ruleId },
      errors: {
        400: 'Bad Request',
        404: 'Not Found',
        422: 'Unprocessable Content',
        500: 'Internal Server Error'
      }
    })
  }

  public static deactivateRule(id: number): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/DeactivateRule',
      query: { id },
      errors: {
        400: 'Bad Request',
        404: 'Not Found'
      }
    })
  }

  public static saveRule(conditions: SaveRuleDto): CancelablePromise<RuleDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/Rule',
      body: conditions,
      mediaType: 'application/json',
      errors: {
        400: 'Bad Request',
        404: 'Not Found'
      }
    })
  }

  public static ruleApplicableInstructionsDescriptors(
    nodeType: number
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/Rule_Applicable_Instructions_Descriptors',
      query: {
        nodeType: nodeType
      },
      errors: {
        400: 'Bad Request',
        404: 'Not Found'
      }
    })
  }

  public static resendForCustomerApproval(
    quotationId: string
  ): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/resend-for-customer-approval',
      query: { quotationId },
      errors: {
        400: 'Bad Request',
        404: 'Not Found'
      }
    })
  }

  public static getCustomerEmailContentData(
    quotationId: string
  ): CancelablePromise<GetCustomerEmailContentDataDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/get-customer-email-content-data',
      query: { quotationId },
      errors: {
        400: 'Bad Request',
        404: 'Not Found'
      }
    })
  }
}
